import type { ReactElement } from "react";

import type { LinkProps } from "react-router-dom";

import { styled } from "simplydo/react/styled";

import type { DropdownItemProps } from "./Dropdown.types";
import { RenderDropdownItem } from "./DropdownItem";

export type DropdownItemLinkProps = DropdownItemProps &
  Omit<LinkProps, "color" | "children" | "className" | "to"> & {
    to?: LinkProps["to"];
    href?: string;
  };

const DropdownItemLinkComponent = (
  props: DropdownItemLinkProps,
): ReactElement => <RenderDropdownItem {...props} asLink />;

export const DropdownItemLink = styled(DropdownItemLinkComponent)``;
